export default {
  widgets: {
    shippedItems: {
      filters: {
        search: {
          placeholder: 'Qidiruv...',
        },
        statuses: {
          placeholder: 'Holati',
          options: ['Yangi', 'Jarayonda', 'O‘tkazib yuborilgan', 'Tamomlangan', 'Bekor qilingan'],
          new: 'Yangi',
          processing: 'Jarayonda',
          missed: 'O‘tkazib yuborilgan',
          completed: 'Tamomlangan',
          canceled: 'Bekor qilingan',
        },

        reset: 'Qaytish',
      },
      headers: {
        invoiceId: 'Yuk xati ID raqami',
        name: 'Nom',
        items: 'Tovarlar',
        itemsQuantity: 'Tovarlar soni',
        dateAndTime: 'Sana va vaqt',
        status: 'Holati',
        sku: 'SKU',
        ikpu: 'MXIK',
        price: 'Narxi',
        price_brutto: 'QQS bilan narx',
        quantity: 'Omborda',
        inAlifshop: 'Alifshopda',
      },
    },
  },
};
